class Receipt {
  constructor({ paymentResult, items, discount, offer, tierPrivileges }) {
    this.paymentResult = paymentResult;
    this.items = items;
    this.discount = discount;
    this.offer = offer;
    this.tierPrivileges = tierPrivileges;
  }

  get itemList() {
    return this.items.map((item) => ({
      name: item.productName,
      qty: item.qty,
      price: item.chargeAmount * item.qty,
      code: item.code,
    }));
  }

  get totalQTY() {
    return this.items.reduce((total, item) => total + item.qty, 0);
  }

  get totalPrice() {
    return this.items.reduce(
      (total, item) => total + item.chargeAmount * item.qty,
      0
    );
  }

  get totalDiscount() {
    return (
      (this.discount?.getTotalDiscount(this.totalPrice) ?? 0) +
      (this.offer?.getTotalDiscount(this.totalPrice) ?? 0) +
      (this.tierPrivileges?.reduce(
        (total, privilege) =>
          total + privilege.coupon.getDiscountNumber(this.totalPrice),
        0
      ) ?? 0)
    );
  }

  get totalPriceafterDiscount() {
    return this.totalPrice - this.totalDiscount;
  }

  get vat() {
    return (this.totalPriceafterDiscount * 7) / 100;
  }

  get id() {
    return this.paymentResult.id;
  }

  get date() {
    return this.paymentResult.date;
  }
}

export default Receipt;
